export default "/SiteCollectionImages/react-apps/nykredit/src/images/icons/oops50.svg";